











































































































































import { Vue, Component } from "vue-property-decorator";
import { bus } from "../main";

@Component
export default class Alert extends Vue {
  private message: string;
  private snackbarSuccess: boolean;
  private snackbarError: boolean;
  private snackbarIncomplete: boolean;
  private snackbarNoDoc: boolean;
  private snackbarWarning: boolean;

  constructor() {
    super();
    this.message = "";
    this.snackbarSuccess = false;
    this.snackbarError = false;
    this.snackbarIncomplete = false;
    this.snackbarNoDoc = false;
    this.snackbarWarning = false;
  }

  private normalizeErrorMessage(payload: any): string {
    const fallback = "Errore del server";

    const toText = (value: any): string | null => {
      if (value === null || value === undefined) {
        return null;
      }

      if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed) {
          return null;
        }
        const axiosStatusMatch = trimmed.match(/^Request failed with status code\s+(\d{3})$/i);
        if (axiosStatusMatch) {
          const lastBackendError = (globalThis as any).__valtisLastBackendError;
          const code = parseInt(axiosStatusMatch[1], 10);
          if (
            lastBackendError &&
            typeof lastBackendError.message === "string" &&
            lastBackendError.message.trim() &&
            (!lastBackendError.status || lastBackendError.status === code) &&
            typeof lastBackendError.at === "number" &&
            Date.now() - lastBackendError.at < 15000
          ) {
            return lastBackendError.message.trim();
          }
        }
        // Avoid showing plain numeric codes like "500" as full messages.
        if (/^\d{3}$/.test(trimmed)) {
          return null;
        }
        return trimmed;
      }

      if (typeof value === "number") {
        return null;
      }

      if (Array.isArray(value)) {
        const parts: string[] = [];
        for (const item of value) {
          const text = toText(item);
          if (text) {
            parts.push(text);
          }
        }
        return parts.length > 0 ? parts.join("\n") : null;
      }

      if (typeof value === "object") {
        // Axios-style wrappers.
        const axiosCandidates = [value.response, value.data, value.error];
        for (const candidate of axiosCandidates) {
          const text = toText(candidate);
          if (text) {
            return text;
          }
        }

        // Common backend message fields.
        const commonFields = [
          "message",
          "Message",
          "error_description",
          "errorDescription",
          "error",
          "detail",
          "details",
          "title",
          "descrizione",
          "Description"
        ];
        for (const key of commonFields) {
          if (Object.prototype.hasOwnProperty.call(value, key)) {
            const text = toText(value[key]);
            if (text) {
              return text;
            }
          }
        }

        // Validation dictionaries like { errors: { field: ["msg"] } }
        if (Object.prototype.hasOwnProperty.call(value, "errors")) {
          const text = toText(value.errors);
          if (text) {
            return text;
          }
        }

        // Generic object fallback: collect readable properties.
        const collected: string[] = [];
        for (const key in value) {
          if (!Object.prototype.hasOwnProperty.call(value, key)) {
            continue;
          }
          const text = toText(value[key]);
          if (text) {
            collected.push(text);
          }
        }

        if (collected.length > 0) {
          return collected.join("\n");
        }
      }

      return null;
    };

    return toText(payload) || fallback;
  }

  created() {
    bus.$on("successfullOperation", (data: any) => {
      this.message = data;
      this.snackbarSuccess = true;
    });

    bus.$on("errorOperation", (data: any) => {
      this.message = this.normalizeErrorMessage(data);
      this.snackbarError = true;
    });

    bus.$on("incompleteInfo", () => {
      this.snackbarIncomplete = true;
    });

    bus.$on("warning", (data: any) => {
      this.message = data;
      this.snackbarWarning = true;
    });

    bus.$on("noDoc", (data: any) => {
      this.message = data;
      this.snackbarNoDoc = true;
    });
  }
}
